import { useControlOptions } from "@lib/logic";
import type { Controllable } from "@lib/store";
import { Button } from "@molecules";
import { cn } from "@utils";

import { GradientBar } from "./GradientBar";

// The control's settings, next to a bar that shows the range they run along
export const ControlOptions = ({ control, nodeId }: { control: Controllable; nodeId: string }) => {
  const options = useControlOptions(control, nodeId);

  return (
    <div className="flex gap-5">
      <div className="flex flex-1 flex-col gap-1">
        {options.map(({ title, action, disabled, isActive, isLoading }) => (
          <Button
            key={title}
            className={cn("h-12", { "border-mapiq-black-800*": isActive })}
            button="tertiary"
            loading={isLoading}
            disabled={disabled}
            onClick={action}>
            {title}
          </Button>
        ))}
      </div>

      <GradientBar type={control.type} />
    </div>
  );
};
